'use client'

import type {
  BundleProductCardInfoFragment,
  ProductCard_ProductPriceAndStockFragment,
} from '@gql-generated/graphql'
import type { PropsWithChildren } from 'react'
import { createContext, useCallback, useContext, useState } from 'react'

type SelectableItem = BundleProductCardInfoFragment & ProductCard_ProductPriceAndStockFragment

// TODO: Use a generic type to prevent the use of anything related to products.
export type SelectableContextProps = {
  selectedIds: BundleProductCardInfoFragment['reference'][]
  items: SelectableItem[]
  toggleItem: (id: string) => void
  isDisabled: boolean
  setIsDisabled: (isDisabled: boolean) => void
}

const SelectableContext = createContext<SelectableContextProps | null>(null)

export const useSelectable = () => {
  return useContext(SelectableContext)
}

type SelectableProviderProps = PropsWithChildren & {
  items: SelectableItem[]
}

export function SelectableProvider({
  items,
  children,
}: SelectableProviderProps): React.ReactElement {
  const [isDisabled, setIsDisabled] = useState(false)
  const [selectedIds, setSelectedIds] = useState<string[]>(items.map((item) => item.reference))

  const toggleItem = useCallback((id: string) => {
    setSelectedIds((prev) => {
      if (prev.indexOf(id) > -1) {
        return prev.filter((theId) => theId !== id)
      } else {
        return [...prev, id]
      }
    })
  }, [])

  return (
    <SelectableContext.Provider
      value={{ selectedIds, items, toggleItem, isDisabled, setIsDisabled }}
    >
      {children}
    </SelectableContext.Provider>
  )
}
